import {Component, inject, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompteComptableService} from '../../core/services/entities/compte-comptable.service';
import {CompteComptableDTO} from '../../core/dtos/compte-comptable-dto';
import {ToastService} from '../../core/services/technique/toast.service';
import {InternationalizationService} from '../../core/services/i8n/i8n.service';
import {UtilsService} from '../../core/utils/utils.service';
import {MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {confirm} from 'devextreme/ui/dialog';
import {ButtonThemeEnum} from '../../shared/ui/button/button-theme-enum';
import {DxDataGridModule, DxToolbarModule} from 'devextreme-angular';
import {CompteComptableDialogComponent} from './compte-comptable-dialog/compte-comptable-dialog.component';
import {SharedModule} from '../../shared/shared.module';

@Component({
  selector: 'yo-comptes-comptables',
  templateUrl: './comptes-comptables.component.html',
  styleUrls: ['./comptes-comptables.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    DxDataGridModule,
    DxToolbarModule,
    CompteComptableDialogComponent
  ]
})
export class ComptesComptablesComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  readonly compteComptableSvc = inject(CompteComptableService);
  private readonly toastSvc = inject(ToastService);
  private readonly i8nSvc = inject(InternationalizationService);
  readonly utils = inject(UtilsService);

  selectedRows: number[] = [];
  readonly showDialog = signal(false);
  readonly editingDto = signal<CompteComptableDTO | null>(null);

  openDialogEdition = (dto: CompteComptableDTO | null): void => {
    this.editingDto.set(dto);
    this.showDialog.set(true);
  };

  onSaved = ({dto, isUpdate}: { dto: CompteComptableDTO; isUpdate: boolean }): void => {
    this.compteComptableSvc.comptesComptablesResource.update(current => {
      const list = current ?? [];
      return isUpdate
        ? list.map(c => c.id === dto.id ? dto : c)
        : [...list, dto];
    });
  };

  calculateSiteValue = (dto: CompteComptableDTO): string => dto?.site?.libelle ?? '';

  canDelete = (): boolean => this.selectedRows.length > 0;

  deleteValues = async (): Promise<void> => {
    const idsToDelete = [...this.selectedRows];

    const confirmed: boolean = await confirm(
      this.i8nSvc.getLabelFromCode(idsToDelete.length > 1 ? 'CONFIRM_DELETION_PLURAL' : 'CONFIRM_DELETION_SINGULAR', null),
      this.i8nSvc.getLabelFromCode('Suppression', null)
    );

    if (!confirmed) { return; }

    this.compteComptableSvc.delete(idsToDelete).subscribe(() => {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
        idsToDelete.length > 1
          ? 'Les comptes comptables ont bien été supprimés'
          : 'Le compte comptable a bien été supprimé');
      this.compteComptableSvc.comptesComptablesResource.update(
        current => (current ?? []).filter(c => !idsToDelete.includes(c.id))
      );
      this.selectedRows = [];
    });
  };
}
